import React, { memo } from 'react';
import ErrorBoundary from '@/app/common/components/ErrorBoundary';
import {
  StyledAdv,
  BottomLeaderboardContainer,
  IntraListAdvContainer,
  BottomDoubleMPUContainer,
  BottomDoubleMPULeftContainer,
  BottomDoubleMPURightContainer,
  TopLeaderboardContainer,
} from './styled.ts';

type AdvProps = {
  id: string;
  id2?: string;
  hide?: boolean;
  isBottom?: boolean;
  isIntraList?: boolean;
  isDouble?: boolean;
  isTop?: boolean;
};

const Adv: React.FC<AdvProps> = ({ id, id2, hide, isTop, isBottom, isIntraList, isDouble }) => {
  if (isTop) {
    return (
      <ErrorBoundary id="Adv_isTop">
        <TopLeaderboardContainer hide={!!hide}>
          <StyledAdv id={id} />
        </TopLeaderboardContainer>
      </ErrorBoundary>
    );
  }

  if (isBottom) {
    return (
      <ErrorBoundary id="Adv_isBottom">
        <BottomLeaderboardContainer hide={!!hide}>
          <StyledAdv id={id} />
        </BottomLeaderboardContainer>
      </ErrorBoundary>
    );
  }

  if (isIntraList) {
    return (
      <ErrorBoundary id="Adv_isIntraList">
        <IntraListAdvContainer id={id} hide={!!hide} />
      </ErrorBoundary>
    );
  }

  if (isDouble) {
    return (
      <ErrorBoundary id="Adv_isDouble">
        <BottomDoubleMPUContainer hide={!!hide}>
          <BottomDoubleMPULeftContainer>
            <StyledAdv id={id} />
          </BottomDoubleMPULeftContainer>
          <BottomDoubleMPURightContainer>
            <StyledAdv id={id2} />
          </BottomDoubleMPURightContainer>
        </BottomDoubleMPUContainer>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary id="Adv">
      <StyledAdv id={id} />
    </ErrorBoundary>
  );
};

export default memo(Adv);
